<template>
  <div class="container my-5">
    <div class="card mb-4">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col d-flex align-items-center">
            <h2 class="card-title text-truncate mb-0">{{ lead.first_name }} {{ lead.surname }}</h2>
          </div>
          <div class="col-auto">
            <button
              type="button"
              class="btn btn-sm btn-link"
              v-c-modal:editModal="{}"
            >
              <i class="far fa-pencil-alt"></i>
              Edit
            </button>
          </div>
        </div>
        <div class="row">
          <div v-if="lead.company" class="col-sm-6 col-lg">
            <p>
              <span class="data-label">Company</span>
              {{ lead.company }}
            </p>
          </div>
          <div class="col-sm-6 col-lg">
            <p class="text-truncate">
              <span class="data-label">Email</span>
              {{ lead.email }}
            </p>
          </div>
          <div v-if="lead.phone" class="col-sm-6 col-lg">
            <p>
              <span class="data-label">Phone</span>
              {{ lead.phone }}
            </p>
          </div>
          <div v-if="lead.mobile" class="col-sm-6 col-lg">
            <p>
              <span class="data-label">Mobile</span>
              {{ lead.mobile }}
            </p>
          </div>
          <div class="col-sm-6 col-lg">
            <p>
              <span class="data-label">Received</span>
              {{ lead.created_at | moment('DD/MM/YYYY') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-body">
        <h2 class="card-title mb-3">Message</h2>
        <p class="lead-message mb-0">{{ lead.message }}</p>
      </div>
    </div>

    <a href="#" class="text-danger" @click.prevent="confirmArchive">Archive</a>

    <lead-modal ref="editModal" title="Edit Lead" :lead="lead" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LeadModal from './LeadModal'

export default {
  components: {
    LeadModal
  },

  computed: {
    ...mapState('lead', {
      lead: 'single'
    })
  },

  methods: {
    ...mapActions('lead', { deleteSingle: 'deleteSingle' }),

    confirmArchive () {
      this.$swal({
        title: 'Confirm Archive',
        html: 'Are you sure you want to archive this lead',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Archive'
      }).then(() => {
        this.deleteSingle(this.lead.id).then(() => this.$router.push({ name: 'leads.index' }))
      }, () => {})
    }
  }
}
</script>

<style scoped>
.lead-message {
  white-space: pre-wrap;
}
</style>
